"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePositionTradingFeeSum = void 0;
const common_business_1 = require("@pionex-web-kit/common-business");
const rxjs_1 = require("rxjs");
const FutureAPI_1 = require("../../../apis/FutureAPI");
function usePositionTradingFeeSum() {
    return (0, common_business_1.useAsyncFn)((params) => (0, rxjs_1.firstValueFrom)((0, FutureAPI_1.queryPositionTradingFeeSum)(params)));
}
exports.usePositionTradingFeeSum = usePositionTradingFeeSum;
